import ActionTypes from "../constants/ActionTypes";
import api from '../constants/api';
import { delete_cookie, history, setCookie } from "../helpers";
import { authHeader } from "../helpers";
import { postApi } from '../helpers/http';

export const requestUsers = (date) => ({
   type: ActionTypes.REQUEST_USER,
   date,
});

export const receiveUsers = (params, json) => ({
   type: ActionTypes.RECEIVE_USER,
   date: params.date,
   items: json.data,
   receivedAt: Date.now(),
});

const doFetchUsers = (params) => async (dispatch) => {
   dispatch(requestUsers(params));

   const data = {
      "process_type": "getDataUserList",
      "user_name": params.user_name,
      "user_id": params.user_id,
      "section_name": params.section_name,
      "section_id": params.section_id,
      "pc_name": params.pc_name,
      "mac_add": params.mac_add,
      "department_name": params.department_name,
      "department_id": params.department_id,
      "offset": params.offset,
      "limit": params.limit,
   };

   try {
      const json = await postApi(data);
      dispatch(receiveUsers(params, json));
   } catch (error) {
      console.error('Error:', error);
   };

   // return fetch(
   //    api.url,
   //    {
   //       method: "POST",
   //       headers: authHeader(),
   //       body: JSON.stringify(data),
   //    }
   // )
   //    .then((response) => response.json())
   //    .then((json) => {
   //       // console.log('Success:', json.data);
   //       dispatch(receiveUsers(params, json));
   //    })
   //    .catch((error) => {
   //       console.error("Error:", error);
   //    });
};

export const fetchUsers = (params) => (dispatch, getState) => {
   return dispatch(doFetchUsers(params));
};

export const request = (user, message) => ({
   type: ActionTypes.LOGIN_REQUEST,
   user,
   message,
});

export const success = (user, message) => ({
   type: ActionTypes.LOGIN_SUCCESS,
   user,
   message,
});

export const failure = (user, message) => ({
   type: ActionTypes.LOGIN_FAILURE,
   user,
   message,
});

export const rdc_received_otp = (data, message, isNotifyMessage = true) => ({
   type: ActionTypes.RECEIVE_OTP,
   data,
   message,
   isNotifyMessage,
});

export const rdc_verified_otp_failed = (data, message, isNotifyMessage) => ({
   type: ActionTypes.VERIFIED_OTP_FAILED,
   data,
   message,
   isNotifyMessage,
});

export const rdc_resend_otp = (user, data) => ({
   type: ActionTypes.RESEND_OTP,
   user,
   data,
});

// const rdc_login_update_message = (message, isNotifyMessage) => ({
//    type: ActionTypes.LOGIN_UPDATE_MESSAGE,
//    message,
//    isNotifyMessage,
// });

const rdc_set_fetch_state = (isFetching, message, isNotifyMessage) => ({
   type: ActionTypes.SET_FETCH_STATE,
   isFetching,
   message,
   isNotifyMessage,
});

const loginService = (username, password, autologin, relogin = false) => (dispatch) => {
   dispatch(request(username, ""));

   //ログイン用データ設定
   var data = {
      process_type: "login",
      user_data_info: {
         login_email: username,
         password: password,
         relogin: relogin,
      },
   };

   const requestOptions = {
      method: "POST",
      headers: {
         "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
   };

   return fetch(
      api.url,
      requestOptions
   )
      .then((response) => response.json())
      .then((json) => {
         if (
            json.statusCode === 200 &&
            json.data &&
            json.data.isVerifyOtp === true
         ) {
            dispatch(
               rdc_received_otp(
                  json.data,
                  `認証コードを${username}に送信しました。\n登録メールをご確認ください。`,
                  true
               )
            );
         } else if (json.data && json.data.user && json.statusCode !== 400) {
            //Token保存
            const { refresh_token, ...user } = json.data.user;
            if (autologin === true) {
               // console.log('localStorage:', json.data.user);
               setCookie('refresh_token', refresh_token);
               localStorage.setItem("user", JSON.stringify(user));
               sessionStorage.removeItem("user");
            } else {
               // console.log('sessionStorage:', json.data.user);
               setCookie('refresh_token', refresh_token);
               sessionStorage.setItem("user", JSON.stringify(user));
               localStorage.removeItem("user");
            }

            dispatch(success(json.data.user, ""));
            history.push("/index.html");            
         } else if (json.data && json.statusCode == 500) {
            dispatch(
               failure(username, json.data.message.replace(/<br\s*\/?>/gi, "\n"))
            );
         } else {
            dispatch(
               failure(username, "ログインＩＤとパスワードを確認してください。")
            );
         }
      })
      .catch((error) => {
         dispatch(failure(username, error.toString()));
         console.error("Error:", error);
      });
};

const verifyService = (otpcode, otpdata, autologin) => (dispatch) => {
   dispatch(setFetchStateService(true, "", false));
   //ログイン用データ設定
   var data = {
      process_type: "login",
      sub_process: "verify_otp",
      user_data_info: {
         ...otpdata,
         otp_code: otpcode,
      },
   };

   console.log("verify_data:", data);

   const requestOptions = {
      method: "POST",
      headers: {
         "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
   };
   return fetch(
      api.url,
      requestOptions
   )  
      .then((response) => response.json())
      .then((json) => {
         //コードの認証に成功しました場合にレスポンスのペイロード内にユーザーデータが入ります。
         if (json.data && json.data.user && json.statusCode === 200) {
            //Token保存
            const { refresh_token, ...user } = json.data.user;
            if (autologin === true) {
               setCookie('refresh_token', refresh_token);
               localStorage.setItem("user", JSON.stringify(user));
               sessionStorage.removeItem("user");
            } else {
               setCookie('refresh_token', refresh_token);
               sessionStorage.setItem("user", JSON.stringify(user));
               localStorage.removeItem("user");
            }
            dispatch(success(json.data.user, ""));
            history.push("/index.html");
         } else {
            dispatch(
               rdc_verified_otp_failed(
                  json.data.data,
                  json.data.message.replace(/<br\s*\/?>/gi, "\n"),
                  false
               )
            );
         }
      })
      .catch((error) => {
         dispatch(failure(otpdata.login_email, error.toString()));
         console.error("Error:", error);
      });
};

const resendOtpService = (username, otpdata) => (dispatch) => {
   dispatch(rdc_resend_otp(username, otpdata));

   //ログイン用データ設定
   let data = {
      process_type: "login",
      sub_process: "regenerate_otp",
      user_data_info: {
         ...otpdata,
         login_email: username,
      },
   };
   console.log("data:", data);

   const requestOptions = {
      method: "POST",
      headers: {
         "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
   };

   return fetch(
      api.url,
      requestOptions
   )
      .then((response) => response.json())
      .then((json) => {
         if (json.statusCode === 200 && json.data) {
            dispatch(
               rdc_received_otp(
                  json.data,
                  `認証コードを${username}に送信しました。\n登録メールをご確認ください。`,
                  true
               )
            );
         } else {
            dispatch(
               rdc_set_fetch_state(
                  false,
                  "データの都合が悪いので認証コードの発行に成功しませんでした。",
                  false
               )
            );
         }
      })
      .catch((error) => {
         dispatch(failure(username, error.toString()));
         console.error("Error:", error);
      });
};

const setFetchStateService =
   (isFetching, message, isNotifyMessage) => (dispatch) => {
      dispatch(rdc_set_fetch_state(isFetching, message, isNotifyMessage));
   };

const logoutService = () => (dispatch) => {
   // remove user from local storage to log user out
   console.log("logoutService");
localStorage.removeItem("user");
   sessionStorage.removeItem("user");
   delete_cookie('refresh_token');
   dispatch({ type: ActionTypes.LOGOUT });
   return { type: ActionTypes.LOGOUT };
};

export const login =
   (username, password, autologin) => (dispatch, getState) => {
      return dispatch(loginService(username, password, autologin));
   };

export const logout = () => (dispatch, getState) => {
   console.log("logout");
   return dispatch(logoutService());
};

export const verifyOtp =
   (otpcode, otpdata, autologin) => (dispatch, getState) => {
      return dispatch(verifyService(otpcode, otpdata, autologin));
   };

export const resendOtp = (username, otpdata) => (dispatch, getState) => {
   return dispatch(resendOtpService(username, otpdata));
};

export const setFetchState =
   (isFetching, message, isNotifyMessage) => (dispatch, getState) => {
      return dispatch(
         setFetchStateService(isFetching, message, isNotifyMessage)
      );
   };


// export const goBack = () => (dispatch, getState) => {
//    return dispatch(() => {
//       return {
//          type: LOG
//       }
//    })
// }
